import { render, staticRenderFns } from "./x-details.vue?vue&type=template&id=3429110c&scoped=true"
import script from "./x-details.vue?vue&type=script&lang=js"
export * from "./x-details.vue?vue&type=script&lang=js"
import style0 from "./x-details.vue?vue&type=style&index=0&id=3429110c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3429110c",
  null
  
)

export default component.exports